<template>
  <v-close-dialog class="taste-fresh"
    :class="{'taste-fresh-closehide': opened}" 
    :show.sync="isTasteFreshDialogShow">
    <div class="taste-fresh-body">
      <div class="taste-fresh-content" v-if="opened">
        <div class="taste-fresh-top">
          <p>请先完善信息进行提额</p>
          <p><span class="taste-fresh-highlight">提升额度</span></p>
        </div>
        <div class="taste-fresh-middle">
          <p>白条提额后可享受更多优惠</p>
        </div>
        <div class="taste-fresh-bottom">
          <p>提额之后才可正常使用{{productName}}</p>
        </div>
        <div class="taste-fresh-button">
          <v-button :clstag="clstagPrefix+'wanShanXinXiKaiTong'"
            @click="goUpGrade">完善信息</v-button>
        </div>
      </div>
      <div class="taste-fresh-content" v-else>
        <div class="taste-fresh-top">
          <p>请先完善信息<span class="taste-fresh-highlight">提升额度</span></p>
          <p>开通<span class="taste-fresh-highlight">{{productName}}</span></p>
        </div>
        <div class="taste-fresh-middle">
          <p>白条提额后可享受更多优惠</p>
        </div>
        <div class="taste-fresh-bottom">
          <p>提额之后才可开通{{productName}}</p>
        </div>
        <div class="taste-fresh-button">
          <v-button :clstag="clstagPrefix+'wanShanXinXi'"
            @click="goUpGrade">完善信息</v-button>
        </div>
      </div>
      <img src="@/assets/modal-bg.png"/>
    </div>
  </v-close-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTasteFreshDialogShow: false,
      documentTitle: window.CONFIG.documentTitle,
      clstagPrefix: window.CONFIG.clstagPrefix
    };
  },
  computed: {
    productName() {
      return this.documentTitle.indexOf('白条') > -1
        ? this.documentTitle
        : `${this.documentTitle}白条`
    }
  },
  methods: {
    goUpGrade() {
      const returnUrl = window.location.href;
      window.location.href = `https://mbt.jd.com/external/taste-fresh/index.html?channelName=BF00039#/upgrade?returnUrl=${
        encodeURIComponent(returnUrl)
      }&extParam=01030103`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/px2rem.scss";
  
.taste-fresh {
  
  &.taste-fresh-closehide {
    /deep/ .dialog-close {
      display: none;
    }
  }
  
  .taste-fresh-body {
    position: relative;
    font-size: px2rem(32);
    
    .taste-fresh-content {
      position: absolute;
      width: 100%;
      padding: px2rem(50);
      
      .taste-fresh-top {
        font-size: px2rem(46);
        line-height: px2rem(72);
        
        .taste-fresh-highlight {
          color: #4D7BFE;
        }
      }
      .taste-fresh-middle {
        line-height: px2rem(64);
        margin-top: px2rem(26);
        color: #3E3732;
      }
      .taste-fresh-bottom {
        margin-top: px2rem(52);
        color: #ADADAD;
      }
      .taste-fresh-button {
        margin-top: px2rem(67);
        
        /deep/ button {
          font-size: px2rem(32);
          height: px2rem(98);
          line-height: px2rem(98);
          border-radius: px2rem(98);
          padding: 0 px2rem(32);
          background: #4D7BFE!important;
        }
      }
    }
  }
  
}
</style>